var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row text-muted"},[_c('div',{staticClass:"col-6 text-left"}),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('p',{staticClass:"mb-0"},[_vm._v("© 2020 - "),_c('a',{staticClass:"text-muted",attrs:{"href":"/"}},[_vm._v("CRM")])])])])])])
}]

export { render, staticRenderFns }